import { BotonExportarExcel, Checkbox, Group, TablaSkeleton, Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { ClaveSatCentroCosto } from "../services/clave-sat-centro-costo-service";
import { ClaveSatCentroCostoRow } from "./ClaveSatCentroCostoRow";

/** Tabla de relaciones clave SAT → centro de costo por sociedad. */
export function ClavesSatCentrosCostoTable({
  cargando = false,
  relaciones,
  obtenerFilasExport,
  seleccionadas,
  onToggle,
  onToggleTodasPagina,
}: {
  /** Primera carga (sin caché) · filas skeleton bajo el encabezado real. */
  cargando?: boolean;
  relaciones: ClaveSatCentroCosto[];
  /** Con paginado server-side: callback que trae TODAS las páginas para el export. */
  obtenerFilasExport?: () => Promise<ClaveSatCentroCosto[]>;
  seleccionadas: Set<string>;
  onToggle: (id: string) => void;
  /** Marca/desmarca todas las filas de la página actual. */
  onToggleTodasPagina: () => void;
}) {
  const todasPagina = relaciones.length > 0 && relaciones.every((r) => seleccionadas.has(r.id));
  const algunaPagina = relaciones.some((r) => seleccionadas.has(r.id));
  const estadoHeader: boolean | "indeterminate" = todasPagina ? true : algunaPagina ? "indeterminate" : false;
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="clave-sat-centro-costo"
          hoja="Centros de costo por clave"
          filas={obtenerFilasExport ? undefined : relaciones}
          obtenerFilas={obtenerFilasExport}
          columnas={[
            { header: "Clave SAT", value: (r) => r.claveSat },
            { header: "Descripción clave", value: (r) => r.claveSatDescripcion },
            { header: "Sociedad", value: (r) => r.numeroSociedad },
            { header: "Centro de costo código", value: (r) => r.centroCodigo },
            { header: "Centro de costo nombre", value: (r) => r.centroNombre },
            { header: "Automático", value: (r) => (r.esAutomatico ? "Sí" : "No") },
            { header: "Estado", value: (r) => (r.activo ? "Activo" : "Inactivo") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>
              <Checkbox
                checked={estadoHeader}
                onCheckedChange={() => onToggleTodasPagina()}
                aria-label="Seleccionar todas las de esta página"
              />
            </Th>
            <Th>Clave SAT</Th>
            <Th>Descripción clave</Th>
            <Th>Sociedad</Th>
            <Th>Centro de costo</Th>
            <Th>Prorrateo automático</Th>
            <Th>Estado</Th>
            <Th />
          </Tr>
        </Thead>
        {cargando ? (
          <TablaSkeleton dentroDeTabla columnas={[{}, {}, {}, {}, {}, {}, {}, { align: "right" }]} filas={15} conCheckbox />
        ) : (
          <Tbody>
            {relaciones.map((r) => (
              <ClaveSatCentroCostoRow
                key={r.id}
                relacion={r}
                seleccionada={seleccionadas.has(r.id)}
                onToggleSeleccion={() => onToggle(r.id)}
              />
            ))}
            {relaciones.length === 0 && (
              <Tr>
                <Td colSpan={8}>
                  <Text size="sm" c="dimmed" ta="center" className="py-3">
                    Sin relaciones. Crea la primera con "Nueva relación".
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        )}
      </Table>
    </div>
  );
}
